module.exports = __webpack_public_path__ + "img/ebazaar.fd34041f.svg";